export default __webpack_public_path__ + "static/media/3x.d20bfd10.svg";